<template>
  <div
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-form label-position="right" label-width="80px" class="search-form">
      <el-form-item label="查询时间" class="time-box">
        <el-date-picker
          v-model="searchTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
        ></el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="onSubmit">查询</el-button>
    </el-form>
    <el-table :data="weekData" border style="width: 100%" height="600">
      <el-table-column fixed prop="date" label="日期/时间" width="150"></el-table-column>
      <el-table-column prop="day1" :label="'周一（'+dateList.day1+'）'" width="175">
        <template slot-scope="scope">
          <div
            v-for="(item,idx) in scope.row.day1"
            :key="idx"
            :style="{color:item.color}"
            class="info-div"
            @click="toDetails(item.id)"
          >
            <div>{{item.startTime}} - {{item.endTime}}</div>
            <div>{{item.name}}&nbsp;{{item.coachName}}&nbsp;{{item.courseName}}</div>
            <div class="info-payNum" v-if="item.payNum && item.courseType=='训练课程'">{{item.payNum}}</div>
            <div class="info-xlNum" v-if="item.xlNum && item.courseType=='中医诊疗'">{{item.xlNum}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="day2" :label="'周二（'+dateList.day2+'）'" width="175">
        <template slot-scope="scope">
          <div
            v-for="(item,idx) in scope.row.day2"
            :key="idx"
            :style="{color:item.color}"
            class="info-div"
            @click="toDetails(item.id)"
          >
            <div>{{item.startTime}} - {{item.endTime}}</div>
            <div>{{item.name}}&nbsp;{{item.coachName}}&nbsp;{{item.courseName}}</div>
            <div class="info-payNum" v-if="item.payNum && item.courseType=='训练课程'">{{item.payNum}}</div>
            <div class="info-xlNum" v-if="item.xlNum && item.courseType=='中医诊疗'">{{item.xlNum}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="day3" :label="'周三（'+dateList.day3+'）'" width="175">
        <template slot-scope="scope">
          <div
            v-for="(item,idx) in scope.row.day3"
            :key="idx"
            :style="{color:item.color}"
            class="info-div"
            @click="toDetails(item.id)"
          >
            <div>{{item.startTime}} - {{item.endTime}}</div>
            <div>{{item.name}}&nbsp;{{item.coachName}}&nbsp;{{item.courseName}}</div>
            <div class="info-payNum" v-if="item.payNum && item.courseType=='训练课程'">{{item.payNum}}</div>
            <div class="info-xlNum" v-if="item.xlNum && item.courseType=='中医诊疗'">{{item.xlNum}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="day4" :label="'周四（'+dateList.day4+'）'" width="175">
        <template slot-scope="scope">
          <div
            v-for="(item,idx) in scope.row.day4"
            :key="idx"
            :style="{color:item.color}"
            class="info-div"
            @click="toDetails(item.id)"
          >
            <div>{{item.startTime}} - {{item.endTime}}</div>
            <div>{{item.name}}&nbsp;{{item.coachName}}&nbsp;{{item.courseName}}</div>
            <div class="info-payNum" v-if="item.payNum && item.courseType=='训练课程'">{{item.payNum}}</div>
            <div class="info-xlNum" v-if="item.xlNum && item.courseType=='中医诊疗'">{{item.xlNum}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="day5" :label="'周五（'+dateList.day5+'）'" width="175">
        <template slot-scope="scope">
          <div
            v-for="(item,idx) in scope.row.day5"
            :key="idx"
            :style="{color:item.color}"
            class="info-div"
            @click="toDetails(item.id)"
          >
            <div>{{item.startTime}} - {{item.endTime}}</div>
            <div>{{item.name}}&nbsp;{{item.coachName}}&nbsp;{{item.courseName}}</div>
            <div class="info-payNum" v-if="item.payNum && item.courseType=='训练课程'">{{item.payNum}}</div>
            <div class="info-xlNum" v-if="item.xlNum && item.courseType=='中医诊疗'">{{item.xlNum}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="day6" :label="'周六（'+dateList.day6+'）'" width="175">
        <template slot-scope="scope">
          <div
            v-for="(item,idx) in scope.row.day6"
            :key="idx"
            :style="{color:item.color}"
            class="info-div"
            @click="toDetails(item.id)"
          >
            <div>{{item.startTime}} - {{item.endTime}}</div>
            <div>{{item.name}}&nbsp;{{item.coachName}}&nbsp;{{item.courseName}}</div>
            <div class="info-payNum" v-if="item.payNum && item.courseType=='训练课程'">{{item.payNum}}</div>
            <div class="info-xlNum" v-if="item.xlNum && item.courseType=='中医诊疗'">{{item.xlNum}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="day7" :label="'周日（'+dateList.day7+'）'" width="175">
        <template slot-scope="scope">
          <div
            v-for="(item,idx) in scope.row.day7"
            :key="idx"
            :style="{color:item.color}"
            class="info-div"
            @click="toDetails(item.id)"
          >
            <div>{{item.startTime}} - {{item.endTime}}</div>
            <div>{{item.name}}&nbsp;{{item.coachName}}&nbsp;{{item.courseName}}</div>
            <div class="info-payNum" v-if="item.payNum && item.courseType=='训练课程'">{{item.payNum}}</div>
            <div class="info-xlNum" v-if="item.xlNum && item.courseType=='中医诊疗'">{{item.xlNum}}</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar.vue";
import HelpHint from "@/components/HelpHint.vue";
export default {
  data() {
    return {
      weekData: [],
      loading: false,
      searchTime: "",
      dateList: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    onSubmit() {
      this.getData(this.searchTime);
    },
    getData(time) {
      var that = this;
      that.loading = true;
      this.$axios
        .post(this.baseUrl + "/queryWeekOrder", {
          courseStatus: 1,
          startTime: time
        })
        .then(res => {
          that.loading = false;
          console.log(res);
          this.weekData = res.data.data.infoList;
          this.dateList = res.data.data.startTime;
          console.log(this.weekData);
        })
        .catch(error => {
          console.log(error);
        });
    },
    toDetails(id) {
      console.log(id);
      this.$router.push("/post_details?id=" + id + "&courseStatus=1");
    }
  },
  components: {
    ToolBar,
    HelpHint
  }
};
</script>
<style scoped>
.info-div {
  cursor: pointer;
  text-align: center;
  position: relative;
}
.search-form {
  margin: 20px auto 0;
  overflow: hidden;
}
.time-box {
  float: left;
  margin-right: 100px;
}
.info-payNum {
  position: absolute;
  top: 0px;
  right: -8px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  background: red;
  color: #fff;
  font-size: 12px;
}
.info-xlNum {
  position: absolute;
  top: 0px;
  left: -8px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  background: green;
  color: #fff;
  font-size: 12px;
}
</style>
